var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-programs" },
    [
      _vm._l(_vm.product.items, function (program) {
        return program.active
          ? _c(
              "div",
              {
                staticClass: "program-type",
                class: { module: program.module },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "row program-item",
                    class:
                      "group-" +
                      _vm.product.name.replace(/\s+/g, "").toLowerCase(),
                  },
                  [
                    _c("div", { staticClass: "col-md product-name" }, [
                      _c("div", { staticClass: "program-icon" }, [
                        _c("img", {
                          attrs: {
                            src:
                              "images/program-icons/" +
                              program.predator +
                              ".svg",
                            alt: "icon",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "program-description" }, [
                        _c(
                          "span",
                          { staticClass: "program-description__main" },
                          [_vm._v(_vm._s(program.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "program-description__small" },
                          [_vm._v(_vm._s(program.description))]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mobile-row d-lg-none" }, [
                      _c("div", { staticClass: "row no-gutters flex-nowrap" }, [
                        _c("div", { staticClass: "col col-title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                program.program_type == "bundle"
                                  ? _vm.getTranslation(
                                      "product-list-vue",
                                      "package"
                                    ) + ":"
                                  : program.program_type == "module"
                                  ? _vm.getTranslation(
                                      "product-list-vue",
                                      "module"
                                    ) + ":"
                                  : _vm.getTranslation(
                                      "product-list-vue",
                                      "program"
                                    ) + ":"
                              ) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col col-info" }, [
                          _c("div", { staticClass: "program-icon" }, [
                            _c("img", {
                              attrs: {
                                src:
                                  "images/program-icons/" +
                                  program.predator +
                                  ".svg",
                                alt: "icon",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "program-description" }, [
                            _c(
                              "span",
                              { staticClass: "program-description__main" },
                              [_vm._v(_vm._s(program.name))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "program-description__small" },
                              [_vm._v(_vm._s(program.description))]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.prefix == "lease"
                      ? _c("div", { staticClass: "col-md-1 col-price" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.priceFormat(
                                  _vm.getProgramPrice(
                                    program.id,
                                    "",
                                    _vm.getQtyName("lease", "cloud"),
                                    program.product,
                                    1,
                                    false
                                  ) || 0
                                )
                              ) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mobile-row d-lg-none" }, [
                      _c("div", { staticClass: "row no-gutters flex-nowrap" }, [
                        _c("div", { staticClass: "col col-title" }, [
                          _vm.prefix == "lease"
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getTranslation(
                                      "product-list-vue",
                                      "price_for_lease"
                                    ) + ":"
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm.prefix == "lease"
                          ? _c("div", { staticClass: "col-auto col-info" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.priceFormat(
                                      _vm.getProgramPrice(
                                        program.id,
                                        "",
                                        _vm.getQtyName("lease", "cloud"),
                                        program.product,
                                        1,
                                        true
                                      ) || 0
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.product.purchase_options.has_cloud
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-2 program-quantity col-spinner",
                            },
                            [
                              _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.decreaseQuantity(
                                        program,
                                        _vm.getQtyName(_vm.prefix, "cloud")
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-inline--fa fa-minus fa-w-12 fa-2x",
                                      staticStyle: {
                                        width: "9px",
                                        height: "9px",
                                      },
                                      attrs: {
                                        role: "img",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 384 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      program[
                                        _vm.getQtyName(_vm.prefix, "cloud")
                                      ],
                                    expression:
                                      "program[getQtyName(prefix, 'cloud')]",
                                  },
                                ],
                                staticClass: "quantity",
                                class: {
                                  "is-valid":
                                    program[
                                      _vm.getQtyName(_vm.prefix, "cloud")
                                    ],
                                },
                                attrs: {
                                  type: "text",
                                  pattern: "[0-9]+",
                                  min: "0",
                                  step: "1",
                                  max: "99",
                                  name:
                                    "programs[" +
                                    program.id +
                                    "][" +
                                    _vm.getQtyName(_vm.prefix, "cloud") +
                                    "]",
                                },
                                domProps: {
                                  value:
                                    program[
                                      _vm.getQtyName(_vm.prefix, "cloud")
                                    ],
                                },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        program,
                                        _vm.getQtyName(_vm.prefix, "cloud"),
                                        $event.target.value
                                      )
                                    },
                                    function ($event) {
                                      _vm.addToCart(
                                        program,
                                        _vm.getQtyName(_vm.prefix, "cloud")
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.increaseQuantity(
                                        program,
                                        _vm.getQtyName(_vm.prefix, "cloud")
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-inline--fa fa-plus fa-w-12 fa-2x",
                                      staticStyle: {
                                        width: "9px",
                                        height: "9px",
                                      },
                                      attrs: {
                                        role: "img",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 384 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isTruss4Product(_vm.product.id)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-2 program-quantity col-spinner",
                                },
                                [
                                  _vm.showTrussPeriodSelector(program.product)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-auto col-info program-quantity",
                                          },
                                          [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.trussPeriod,
                                                    expression: "trussPeriod",
                                                  },
                                                ],
                                                attrs: {
                                                  name: "period",
                                                  id: "period_" + program.id,
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.trussPeriod = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    },
                                                    function ($event) {
                                                      return _vm.setTrussPeriod(
                                                        $event
                                                      )
                                                    },
                                                  ],
                                                },
                                              },
                                              _vm._l(
                                                _vm.trussPeriods,
                                                function (period) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: period,
                                                        selected:
                                                          _vm.trussPeriod ===
                                                          period,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            _vm.translateReplace(
                                                              period
                                                            )
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showTrussPeriodText(program.product)
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "col col-title" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.getTranslation(
                                                    "product-list-vue",
                                                    "period"
                                                  )
                                                ) +
                                                ":\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-auto col-info program-quantity",
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.showTrussPeriodText(
                                                    program.product
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mobile-row d-lg-none" }, [
                      _c(
                        "div",
                        { staticClass: "row no-gutters flex-nowrap" },
                        [
                          _vm.product.purchase_options.has_cloud
                            ? [
                                _c("div", { staticClass: "col col-title" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.getTranslation(
                                          "product-list-vue",
                                          "cloud_licences"
                                        )
                                      ) +
                                      ":\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-auto col-info program-quantity",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.decreaseQuantity(
                                              program,
                                              _vm.getQtyName(
                                                _vm.prefix,
                                                "cloud"
                                              )
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "svg-inline--fa fa-minus fa-w-12 fa-2x",
                                            staticStyle: {
                                              width: "9px",
                                              height: "9px",
                                            },
                                            attrs: {
                                              role: "img",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              viewBox: "0 0 384 512",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                fill: "currentColor",
                                                d: "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            program[
                                              _vm.getQtyName(
                                                _vm.prefix,
                                                "cloud"
                                              )
                                            ],
                                          expression:
                                            "program[getQtyName(prefix, 'cloud')]",
                                        },
                                      ],
                                      staticClass: "quantity",
                                      class: {
                                        "is-valid":
                                          program[
                                            _vm.getQtyName(_vm.prefix, "cloud")
                                          ],
                                      },
                                      attrs: {
                                        type: "text",
                                        pattern: "[0-9]+",
                                        min: "0",
                                        step: "1",
                                        max: "999",
                                        name:
                                          "programs[" +
                                          program.id +
                                          "][" +
                                          _vm.getQtyName(_vm.prefix, "cloud") +
                                          "]",
                                      },
                                      domProps: {
                                        value:
                                          program[
                                            _vm.getQtyName(_vm.prefix, "cloud")
                                          ],
                                      },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              program,
                                              _vm.getQtyName(
                                                _vm.prefix,
                                                "cloud"
                                              ),
                                              $event.target.value
                                            )
                                          },
                                          function ($event) {
                                            _vm.addToCart(
                                              program,
                                              _vm.getQtyName(
                                                _vm.prefix,
                                                "cloud"
                                              )
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.increaseQuantity(
                                              program,
                                              _vm.getQtyName(
                                                _vm.prefix,
                                                "cloud"
                                              )
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "svg-inline--fa fa-plus fa-w-12 fa-2x",
                                            staticStyle: {
                                              width: "9px",
                                              height: "9px",
                                            },
                                            attrs: {
                                              role: "img",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              viewBox: "0 0 384 512",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                fill: "currentColor",
                                                d: "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mobile-row d-lg-none" }, [
                      _c(
                        "div",
                        { staticClass: "row no-gutters flex-nowrap" },
                        [
                          _vm.showTrussPeriodSelector(program.product)
                            ? [
                                _c("div", { staticClass: "col col-title" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.getTranslation(
                                          "product-list-vue",
                                          "period"
                                        )
                                      ) +
                                      ":\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-auto col-info program-quantity",
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.trussPeriod,
                                            expression: "trussPeriod",
                                          },
                                        ],
                                        attrs: {
                                          name: "period",
                                          id: "period_" + program.id,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.trussPeriod = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            function ($event) {
                                              return _vm.setTrussPeriod($event)
                                            },
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.trussPeriods,
                                        function (period) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: period,
                                                selected:
                                                  _vm.trussPeriod === period,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.translateReplace(period)
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showTrussPeriodText(program.product)
                            ? [
                                _c("div", { staticClass: "col col-title" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.getTranslation(
                                          "product-list-vue",
                                          "period"
                                        )
                                      ) +
                                      ":\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-auto col-info program-quantity",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.showTrussPeriodText(
                                            program.product
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.$store.state.cart.loggedInUser
                      ? _c(
                          "div",
                          {
                            staticClass: "col-md-1 col-price col-price--total",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getExistingLicensesCount(program)) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-2 col-price col-price--total" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.rowPrice(program)) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "mobile-row total-price--mobile d-lg-none",
                      },
                      [
                        _vm.$store.state.cart.loggedInUser &&
                        _vm.getExistingLicensesCount(program)
                          ? _c(
                              "div",
                              { staticClass: "row no-gutters flex-nowrap" },
                              [
                                _c("div", { staticClass: "col col-title" }, [
                                  _c("b", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getTranslation(
                                          "product-list-vue",
                                          "existing_licenses"
                                        )
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-auto col-info" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.getExistingLicensesCount(program)
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row no-gutters flex-nowrap" },
                          [
                            _c("div", { staticClass: "col col-title" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.getTranslation("front", "total")) +
                                    ":"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-auto col-info" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.rowPrice(program)) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "bundles" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }